/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// Multi-file upload selector

namespace('Slzr', function(exports, top) {
  let $;
  const jQuery = ($ = Slzr.jQuery);

  // A simple widget to handle multiple file uploads
  return exports.MultiUploadSelector = class MultiUploadSelector {
    constructor(options) {
      const defaults = {
        // The input container
        input_container: null,
        // The file list container
        file_list: null,
        // Template string for added items
        template: `\
<span class="filename">#{filename}</span>
<input type="text" name="caption[]" />
<p>Caption or Title <a href="#" class="remove-link">Remove</a></p>\
`,
        // Tag to put in container
        item_container_tag: null,
        item_container_attributes: {},
        file_name: 'image[]',
        input_id: null,
        maximum: 8
      };

      // Options extracted from data attributes

      this.options = $.extend({}, defaults, options);
      this.num_files = 0;

      // Set up necessary elements
      this.input_container = $(this.options.input_container);
      this.file_list = $(this.options.file_list);
      this.template = typeof(this.options.template) === 'function' ? this.options.template : _.template(this.options.template);

      if (!this.options['item_container_tag']) { this.options['item_container_tag'] = this.file_list.data('multi-upload-container-tag') || 'li'; }

      // Find the existing input element
      if (this.options.input) {
        this.input_el = $(this.options.input);
      } else if (this.options.input_id) {
        this.input_el = $(`#${this.options.input_id}`);
      } else {
        this.input_el = this.input_container.find('input[type="file"]');
      }

      this.bindEvents(this.input_el);
    }

    bindEvents(obj) {
      return obj.on('change.MultiUploadSelector', () => this.fileSelected());
    }

    // When a file is selected, move the input element into @file_list
    // and create a new input element
    fileSelected(ev) {
      const new_item = $(`<${this.options.item_container_tag}/>`, this.options.item_container_attributes);
      new_item.append(this.template({filename: this.input_el.val().split("\\").pop() }));
      new_item.append(this.input_el);

      // Hook up the remove handler
      new_item.find('.remove-link').click(ev => this.removeFile(ev, new_item));

      // Collect the old attributes from the input element
      const old_attributes = {
        name: this.input_el.attr('name'),
        style: this.input_el.attr('style'),
        class: this.input_el.attr('class'),
        size: this.input_el.attr('size'),
        type: 'file'
      };

      // Clean up and hide the element
      this.input_el
        .off('change.MultiUploadSelector')
        .attr('name', this.options.file_name)
        .hide();
      this.file_list.append(new_item);

      this.num_files++;

      // If we aren't at maximum, create a new input element
      if (this.num_files < this.options.maximum) {
        const new_input = $('<input/>', old_attributes);
        this.bindEvents(new_input);
        new_input.appendTo(this.input_container);
        return this.input_el = new_input;
      } 
        return this.input_el = null;
      
    }

    removeFile(ev, item) {
      item.remove();
      return false;
    }
  };
});
